import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Document';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5.25C4.5 4.00736 5.50736 3 6.75 3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967L19.2803 9.21967C19.421 9.36032 19.5 9.55109 19.5 9.75V18.75C19.5 19.9926 18.4926 21 17.25 21H6.75C5.50736 21 4.5 19.9926 4.5 18.75V5.25ZM6.75 4.5C6.33579 4.5 6 4.83579 6 5.25V18.75C6 19.1642 6.33579 19.5 6.75 19.5H17.25C17.6642 19.5 18 19.1642 18 18.75V10.5H14.25C13.0074 10.5 12 9.49264 12 8.25V4.5H6.75ZM13.5 5.56066L16.9393 9H14.25C13.8358 9 13.5 8.66421 13.5 8.25V5.56066Z" fill="currentColor"/>
  </svg>
`;

const DocumentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 5.25C4.5 4.00736 5.50736 3 6.75 3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967L19.2803 9.21967C19.421 9.36032 19.5 9.55109 19.5 9.75V18.75C19.5 19.9926 18.4926 21 17.25 21H6.75C5.50736 21 4.5 19.9926 4.5 18.75V5.25ZM6.75 4.5C6.33579 4.5 6 4.83579 6 5.25V18.75C6 19.1642 6.33579 19.5 6.75 19.5H17.25C17.6642 19.5 18 19.1642 18 18.75V10.5H14.25C13.0074 10.5 12 9.49264 12 8.25V4.5H6.75ZM13.5 5.56066L16.9393 9H14.25C13.8358 9 13.5 8.66421 13.5 8.25V5.56066Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: DocumentIcon,
  IconSvg: IconSvg
} as IconType;
